import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ContainerDetailAndTitle,
    ContainerDetail,
    ContentTitle,
    Title, Description
} from "./styled";
import React from "react";

const DetailSubscription = (
    {
        title,
        description,
        content,
        style
    }: {
        title: string;
        description?: string;
        content: React.ReactNode
        style?: React.CSSProperties
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ContainerDetailAndTitle background={colors.background} style={style}>
            <ContentTitle>
                <Title color={colors.text}>{title}</Title>
                {description && <Description color={colors.hint}>{description}</Description>}
            </ContentTitle>
            <ContainerDetail>
                {content}
            </ContainerDetail>
        </ContainerDetailAndTitle>
    );
}
export default DetailSubscription;
